
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/item/[item]",
      function () {
        return require("private-next-pages/item/[item].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/item/[item]"])
      });
    }
  